import React from 'react'

import { nutrimaticLabels } from '@/nutrimatic'

/** Marco compartido de la tableta Nutrimatic (bezel, status, grid readout | perform). */
export function LiquidityNutrimaticTabletDeviceShell({
  readout,
  perform,
  performScreen,
}: {
  readout: React.ReactNode
  perform: React.ReactNode
  performScreen?: string
}) {
  return (
    <div className="nm-tablet-stage">
      <div className="nm-tablet-device" data-nutrimatic-tablet>
        <div className="nm-tablet-bezel">
          <div className="nm-tablet-camera" aria-hidden />

          <div className="nm-tablet-status">
            <div className="nm-tablet-status__brand">
              <span className="nm-tablet-status__name">{nutrimaticLabels.productName}</span>
              <span className="nm-tablet-status__edition">{nutrimaticLabels.edition}</span>
            </div>
            <div className="nm-tablet-status__meta">
              <span className="nm-tablet-status__online">
                <span className="nm-tablet-status__dot" aria-hidden />
                {nutrimaticLabels.online}
              </span>
              <span>{nutrimaticLabels.dontPanic}</span>
            </div>
          </div>

          <div className="nm-tablet-screen">
            <div className="nm-tablet-grid">
              {readout}

              <div className="nm-tablet-trade" data-mobile-screen={performScreen}>
                {perform}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
